import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import Loader from "../../../../components/Common/Loader/Loader";
import { getUserByNameActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import SearchSuggestionInput from "../../../AdminPage/GroupManagement/ManageGroup/SearchSuggestionInput/SearchSuggestionInput";
import classes from "./RecallSelectiveForm.module.scss";
import { dateFormatyyyymmdd } from "../../../SocialPage/PollManagement/DistributePoll/DistributePollForm/DistributePollForm";
import { FormattedMessage, useIntl } from "react-intl";
import RecallSelectiveTable from "../RecallSelectiveTable/RecallSelectiveTable";

const RecallSelectiveForm = ({
  selectedSearchShotclassData,
  setselectedSearchShotclassData,
  tenantName,
  setSelectedUserClassAndNameObj,
  selectedUserClassAndNameObj,
  setRecallShotclassesSearchClick,
}) => {
  const intl = useIntl();
  const methods = useForm({});
  const { setValue } = methods;
  const dispatch = useDispatch();
  const [fromMaxDate, setFromMaxDate] = useState(
    dateFormatyyyymmdd(new Date())
  );
  const [toMinDate, setToMinDate] = useState(null);
  const [searchShotclassesData, setsearchShotclassesData] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchClick, setSearchClick] = useState(0);
  const [recallSelectiveResetClick, setRecallSelectiveResetClick] = useState(0);

  const handleFromDate = (e) => {
    setFromDate(e.target.value);
    setSelectedUserClassAndNameObj((prev) => {
      return {
        ...prev,
        user: {
          ...prev?.user,
          fromDate: e.target.value,
        },
      };
    });
    if (e.target.value) setToMinDate(e.target.value);
    else setToMinDate(null);
  };

  const handleToDate = (e) => {
    setToDate(e.target.value);
    setSelectedUserClassAndNameObj((prev) => {
      return {
        ...prev,
        user: {
          ...prev?.user,
          toDate: e.target.value,
        },
      };
    });
    if (e.target.value) setFromMaxDate(e.target.value);
    else setFromMaxDate(null);
  };

  const handleSearch = (e) => {
    const val = e?.target?.value?.trim();
    if (e?.target?.value?.trim()) {
      dispatch(
        getUserByNameActionHandler(
          val,
          "Published",
          setsearchShotclassesData,
          setSearchLoader
        )
      );
    } else {
      setsearchShotclassesData([]);
      setSelectedUserClassAndNameObj((prev) => {
        return {
          ...prev,
          user: {
            ...prev?.user,
            userId: 0,
          },
        };
      });
    }
  };

  const onDropdownOptionClick = (data) => {
    setselectedSearchShotclassData(data);
    setsearchShotclassesData([]);
    setValue("name", data?.val);
    setSelectedUserClassAndNameObj((prev) => {
      return {
        ...prev,
        user: {
          ...prev?.user,
          userId: data?.ID,
        },
      };
    });
  };

  const handleResetClick = () => {
    setValue("fromDate", null);
    setValue("toDate", null);
    setValue("name", null);
    setFromDate(null);
    setToDate(null);
    setToMinDate(null);
    setFromMaxDate(dateFormatyyyymmdd(new Date()));
    setselectedSearchShotclassData(null);
    setSelectedUserClassAndNameObj((prev) => {
      return {
        ...prev,
        user: {
          ...prev?.user,
          userId: 0,
          fromDate: null,
          toDate: null,
        },
      };
    });
    setRecallSelectiveResetClick((prev) => prev + 1);
  };

  const handleSearchClick = () => {
    setSearchClick((prev) => prev + 1);
  };

  return (
    <>
      <div className={classes.recallSelectiveForm}>
        <FormProvider {...methods}>
          <Input
            type="date"
            name="fromDate"
            label="Assignment From Date"
            labelColor="light"
            borderRadius={1}
            height={5}
            width={20}
            max={fromMaxDate}
            onChange={handleFromDate}
            onKeyDown={() => {
              return false;
            }}
          />
          <div className={classes.dashLine}>-</div>
          <Input
            type="date"
            name="toDate"
            label="Assignment To Date"
            labelColor="light"
            borderRadius={1}
            height={5}
            width={20}
            min={toMinDate}
            max={dateFormatyyyymmdd(new Date())}
            onChange={handleToDate}
            onKeyDown={() => {
              return false;
            }}
          />
          <div className={classes.search}>
            <SearchSuggestionInput
              label={<FormattedMessage id="USERGROUP_USERNAME" />}
              name={"name"}
              placeholder={intl.formatMessage({
                id: "REPORT_PLACEHOLDER_USRNAME",
              })}
              search={false}
              height="5"
              gap="1"
              onChange={handleSearch}
              suggestionData={searchShotclassesData}
              onDropdownOptionClick={onDropdownOptionClick}
            />
            {searchLoader && (
              <div className={classes.loader}>
                <Loader height="40%" />
              </div>
            )}
          </div>
          <div className={classes.btn}>
            <Button
              type="submit"
              label={<FormattedMessage id="P_Search" />}
              dark
              width="11"
              height="5"
              disabled={
                (fromDate && toDate) || selectedSearchShotclassData
                  ? false
                  : true
              }
              onClick={handleSearchClick}
            />
            <Button
              label={<FormattedMessage id="RESET_MSG" />}
              dark
              width="11"
              height="5"
              disabled={
                (fromDate && toDate) || selectedSearchShotclassData
                  ? false
                  : true
              }
              onClick={handleResetClick}
            />
          </div>
        </FormProvider>
      </div>
      <RecallSelectiveTable
        tenantName={tenantName}
        selectedUserClassAndNameObj={selectedUserClassAndNameObj}
        searchClick={searchClick}
        setRecallShotclassesSearchClick={setRecallShotclassesSearchClick}
        recallSelectiveResetClick={recallSelectiveResetClick}
      />
    </>
  );
};

export default RecallSelectiveForm;
